var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.canEditProject(_vm.deliverable.project) ? "cardWrapper" : "" },
    [
      _vm.deliverable.emptyCard
        ? _c(
            "button",
            {
              staticClass: "blank-card",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("add-new-empty")
                }
              }
            },
            [
              _c("portal-icon", {
                attrs: { name: "clipboard-list", size: 22 }
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("projects.add-first-deliverable")))
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "kanban-task-card" },
            [
              _c("div", { staticClass: "task-card-title" }, [
                _vm._v(_vm._s(_vm.deliverable.name))
              ]),
              _vm.showStatus && _vm.status
                ? _c(
                    "portal-status-pill",
                    { staticClass: "task-card-status" },
                    [
                      _c("span", {
                        staticClass: "task-status-dot",
                        style: { backgroundColor: _vm.status.hexColor }
                      }),
                      _vm._v(" " + _vm._s(_vm.status.label) + " ")
                    ]
                  )
                : _vm._e(),
              _vm.hasAssignees || _vm.deliverable.dueDate
                ? _c("div", { staticClass: "task-card-meta" }, [
                    _vm.hasAssignees
                      ? _c(
                          "div",
                          { staticClass: "assignees" },
                          _vm._l(_vm.deliverable.assignedToList, function(
                            assignedTo,
                            index
                          ) {
                            return _c("assigned-user", {
                              key: assignedTo,
                              style: {
                                zIndex:
                                  _vm.deliverable.assignedToList.length - index
                              },
                              attrs: {
                                "show-name": false,
                                "assigned-to": assignedTo,
                                "assignable-users": _vm.assignableUsers
                              }
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    _vm.deliverable.dueDate
                      ? _c(
                          "span",
                          { staticClass: "due-date" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "calendar-days", size: 13 }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    _vm.deliverable.dueDate
                                  ).toLocaleString({
                                    month: "short",
                                    day: "numeric"
                                  })
                                ) +
                                " "
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _c("div", { staticClass: "task-card-footer" }, [
                _vm.deliverable.tasks.length
                  ? _c(
                      "button",
                      {
                        staticClass: "mini-badge",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.showTasks = !_vm.showTasks
                          }
                        }
                      },
                      [
                        _c("portal-icon", {
                          attrs: { name: "list-checks", size: 13 }
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTaskCountLabel(_vm.deliverable.tasks)
                            ) +
                            " "
                        ),
                        _c("portal-icon", {
                          attrs: {
                            name: _vm.showTasks ? "chevron-up" : "chevron-down",
                            size: 12
                          }
                        })
                      ],
                      1
                    )
                  : !_vm.readOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "mini-badge",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("projects.add-task")
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.addFirstTask.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("portal-icon", {
                          attrs: { name: "list-checks", size: 13 }
                        }),
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("+")
                        ])
                      ],
                      1
                    )
                  : _c("span"),
                !_vm.deliverable.parentTaskId && _vm.deliverable.subtasks.length
                  ? _c(
                      "button",
                      {
                        staticClass: "mini-badge",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.showSubtasks = !_vm.showSubtasks
                          }
                        }
                      },
                      [
                        _c("portal-icon", {
                          attrs: { name: "repeat", size: 13 }
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.deliverable.subtasks.length) + " "
                        ),
                        _c("portal-icon", {
                          attrs: {
                            name: _vm.showSubtasks
                              ? "chevron-up"
                              : "chevron-down",
                            size: 12
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("tasks", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTasks && _vm.deliverable.tasks.length > 0,
                    expression: "showTasks && deliverable.tasks.length > 0"
                  }
                ],
                ref: "tasks",
                attrs: { deliverable: _vm.deliverable, disabled: _vm.readOnly },
                on: {
                  empty: function($event) {
                    _vm.showTasks = false
                  },
                  "tasks-updated": function($event) {
                    return _vm.updateTasks()
                  }
                }
              })
            ],
            1
          ),
      _vm.showSubtasks
        ? _c(
            "div",
            { staticClass: "subtask-tree" },
            [
              _vm._l(_vm.deliverable.subtasks, function(subtask) {
                return _c(
                  "div",
                  {
                    key: subtask.id,
                    staticClass: "subtask-branch",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.$emit("edit-subtask", subtask)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "branch-line" }),
                    _c("kanban-card", {
                      attrs: {
                        deliverable: subtask,
                        "assignable-users": _vm.assignableUsers,
                        "status-list": _vm.statusList,
                        "show-status": true
                      }
                    })
                  ],
                  1
                )
              }),
              _vm.canEditProject(_vm.deliverable.project)
                ? _c(
                    "button",
                    {
                      staticClass: "add-subtask",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.$emit("add-subtask")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "branch-line" }),
                      _vm._v(" " + _vm._s(_vm.$t("projects.add-task")) + " ")
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }